import BaseEntity from '../../base/BaseEntity.model';
import Persona from '@/models/persona/persona.model';
import SolicitudEvaluacionHogarMiembroDocumento from './documento.model';

export default class SolicitudEvaluacionHogarMiembro extends BaseEntity {
    public solicitudEvaluacionHogarId?: number;
    public parentescoId?: number;
    public parentescoNombre?: string;
    public key?: string;
    public persona?: Persona;
    public personaId?: number;
    public documentos?: SolicitudEvaluacionHogarMiembroDocumento[];

    constructor() {
        super();
        this.solicitudEvaluacionHogarId = undefined;
        this.parentescoId = undefined;
        this.parentescoNombre = undefined;
        this.persona = undefined;
        this.key = undefined;
        this.personaId = undefined;
        this.documentos = [];
    }
}

